import TablaConciliacion from "../../../TablaConciliacion";

function TablaDevimed() {
  return <TablaConciliacion nombreUseCase="devimed" titulo="DEVIMED" />;
}

export default TablaDevimed;
